module.exports = "/build/images/crossQuestion.svg?3902c495cadb983ec975fc6fa87b023a";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/crossQuestion.svg
// module id = 2435
// module chunks = 0